import { Input } from 'antd';
import React, { FC, RefObject, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useInput } from 'hooks/use-input';
import styles from './input-text-field.module.css';

interface Props {
  onChange: (value: string, e: React.FocusEvent<HTMLInputElement>) => void;
  initialValue?: string;
  onClick?: () => void;
  isEdit?: boolean;
  onEnter?: (
    e: React.ChangeEvent<HTMLInputElement>,
    ref: RefObject<Input>,
  ) => void;
}

export const StyledDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const InputTextField: FC<Props> = (props) => {
  const {
    initialValue = '',
    onChange,
    onClick,
    isEdit = false,
    onEnter,
  } = props;

  const [editing, setEditing] = useState(isEdit);

  const toggleEdit = () => {
    setEditing(!editing);
  };

  const [value, onInputChange] = useInput(initialValue);

  const inputRef = useRef<Input>(null);

  useEffect(() => {
    if (editing && !isEdit) {
      inputRef.current?.focus();
    }
  }, [editing, isEdit]);

  const handleOnEnter = (e) => {
    if (onEnter) {
      onEnter(e, inputRef);
    } else {
      e.currentTarget?.blur();
    }
  };

  const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setEditing(false);
    onChange(value, e);
  };

  return editing ? (
    <Input
      ref={inputRef}
      placeholder="—"
      bordered={false}
      size="small"
      value={value}
      onChange={onInputChange}
      onPressEnter={handleOnEnter}
      onBlur={handleOnBlur}
    />
  ) : (
    /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
    /*  TODO:: This is used inside table. But we are yet to
         finalize whether to show taxtarea or input text.
         Based on that refactor this div.
    */
    <StyledDiv
      tabIndex={0}
      className={!value ? styles.placeholder : ''}
      role="button"
      onClick={onClick || toggleEdit}
      onDoubleClick={toggleEdit}
      onKeyPress={toggleEdit}
    >
      {value}
      {!value && '-'}
    </StyledDiv>
    /* eslint-enable jsx-a11y/no-noninteractive-tabindex */
  );
};
